module.exports = __webpack_public_path__ + "img/arrow_back.d5eef796-0de7d3ca.37521e2a.svg";